export default "__VITE_ASSET__wAsWS7lS__"